import { createAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { api, multipartApi } from '../../config/api';
import {
  isCoreContentType,
  mapContentTypeToApi,
  normalizeContentPublishStatus
} from '../../utils/navigationMenu';

const initial = {
  isGetContentListLoading: false,
  isGetContentListSuccess: false,
  isGetContentListFailed: false,
  contentList: {
    allCount: 0,
    savedCount: 0,
    freeCount: 0,
    registeredCount: 0,
    pafCount: 0,
    contentList: []
  },
  getContentListErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isSectionListLoading: false,
  isSectionListSuccess: false,
  isSectionListFailed: false,
  sectionList: [],
  sectionListErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isTagListLoading: false,
  isTagListSuccess: false,
  isTagListFailed: false,
  tagList: [],
  tagListErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isAddNewTagLoading: false,
  isAddNewTagSuccess: false,
  isAddNewTagFailed: false,
  addTagResponse: null,
  isDeleteContentTagLoading: false,
  isDeleteContentTagSuccess: false,
  isDeleteContentTagFailed: false,
  deleteContentTagResponse: null,
  deleteContentTagErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },
  addNewTagErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isAddNewSectionLoading: false,
  isAddNewSectionSuccess: false,
  isAddNewSectionFailed: false,
  addSectionResponse: null,
  addNewSectionErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isAddNewContentLoading: false,
  isAddNewContentSuccess: false,
  isAddNewContentFailed: false,
  addContentResponse: null,
  addNewContentErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isGetContentLoading: false,
  isGetContentSuccess: false,
  isGetContentFailed: false,
  contentDetails: null,
  getContentErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isGetContentForQuizLoading: false,
  isGetContentForQuizSuccess: false,
  isGetContentForQuizFailed: false,
  contentDetailsForQuiz: null,
  getContentErrorContainerForQuiz: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isUpadteContentLoading: false,
  isUpadteContentSuccess: false,
  isUpadteContentFailed: false,
  updateContent: null,
  upadteContentErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isUpadteContentResponsesLoading: false,
  isUpadteContentResponsesSuccess: false,
  isUpadteContentResponsesFailed: false,
  upadteContentResponsesErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isUpadteContentSettingsLoading: false,
  isUpadteContentSettingsSuccess: false,
  isUpadteContentSettingsFailed: false,
  updateContentSettingsResponse: null,
  UpadteContentSettingsErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isDeleteContentLoading: false,
  isDeleteContentSuccess: false,
  isDeleteContentFailed: false,
  deleteContentResponse: null,
  deleteContentErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isPublishContentLoading: false,
  isPublishContentSuccess: false,
  isPublishContentFailed: false,
  publishContentResponse: null,
  publishContentErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isSaveFlashCardLoading: false,
  isSaveFlashCardSuccess: false,
  isSaveFlashCardFailed: false,
  flashCardResponse: null,
  flashCardErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isDeleteQuestionLoading: false,
  isDeleteQuestionSuccess: false,
  isDeleteQuestionFailed: false,
  deleteQuestionResponse: null,
  deleteQuestionErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isAddNewQuizLoading: false,
  isAddNewQuizSuccess: false,
  isAddNewQuizFailed: false,
  addNewQuizResponse: null,
  addNewQuizErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isDeleteQuizLoading: false,
  isDeleteQuizSuccess: false,
  isDeleteQuizFailed: false,
  deleteQuizResponse: null,
  deleteQuizErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isModalOpen: false
};

export const getContentList = createAsyncThunk(
  'content/getContentList',
  async ({ payload, search, contentType, status }, { rejectWithValue }) => {
    try {
      //
      let response;

      if (search == '' || search == null) {
        response = await api.post(
          `content/getAllContentAdmin?contentType=${contentType}&status=${status}`,
          payload
        );
      } else {
        response = await api.post(
          `content/getAllContentAdmin?searchCriteria=${search}&contentType=${contentType}&status=${status}`,
          payload
        );
      }
      return response.data?.payload || initial.usersData;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const getSectionList = createAsyncThunk(
  'content/getSectionList',
  async (_, { rejectWithValue }) => {
    try {
      let response;

      response = await api.get(`metadata/contentSection`);

      return response.data?.payload || initial.sectionList;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const getTagList = createAsyncThunk(
  'content/getTagList',
  async (_, { rejectWithValue }) => {
    try {
      let response;

      response = await api.get(`tags/contentTags`);

      return response.data?.payload || initial.sectionList;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const addNewTag = createAsyncThunk(
  'content/addNewTag',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post('/tags', payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const deleteContentTag = createAsyncThunk(
  'content/deleteContentTag',
  async (payload, { rejectWithValue }) => {
    try {
      const loggedInUserName = encodeURIComponent(
        payload.loggedInUserName || ''
      );
      const response = await api.delete(
        `tags/${payload.contentTagId}?loggedInUserName=${loggedInUserName}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || error.response?.data
      );
    }
  }
);

export const addNewSection = createAsyncThunk(
  'content/addNewSection',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post('/section', payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const addNewContent = createAsyncThunk(
  'content/addNewContent',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await multipartApi.post('/content', formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const getContentById = createAsyncThunk(
  'content/getContentById',
  async ({ encryptId, userId, viewFlag = false }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `content/${encryptId}?userId=${userId}&viewFlag=${viewFlag}`
      );

      return response.data?.payload;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const getContentByIdForQuizInVideo = createAsyncThunk(
  'content/getContentByIdForQuizInVideo',
  async ({ encryptId, userId }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `content/${encryptId}?userId=${userId}&viewFlag=true`
      );

      return response.data?.payload;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const updateContent = createAsyncThunk(
  'content/updateContent',
  async ({ formData, contentId }, { rejectWithValue }) => {
    try {
      const response = await multipartApi.put(
        `content/updateContent/${contentId}`,
        formData
      );
      return response.data?.payload;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const updateContentResponses = createAsyncThunk(
  'content/updateContentResponses',
  async ({ payload, contentId }, { rejectWithValue }) => {
    try {
      const response = await api.put(
        `content/updateContentResponses/${contentId}`,
        payload
      );
      return response.data?.payload;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const updateContentSettings = createAsyncThunk(
  'content/updateContentSettings',
  async ({ payload, contentId }, { rejectWithValue }) => {
    try {
      const response = await api.put(
        `content/updateContentSettings/${contentId}`,
        payload
      );
      return response.data?.payload;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const deleteContent = createAsyncThunk(
  'content/deleteContent',
  async ({ payload }, { rejectWithValue }) => {
    try {
      const response = await api.put(
        `content/deleteContent/${payload?.contentId}?loggedInUserName=${payload?.loggedInUserName}`
      );
      return response.data?.payload;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const publishContent = createAsyncThunk(
  'content/publishContent',
  async ({ payload }, { rejectWithValue }) => {
    try {
      const contentId = payload?.contentId ?? payload?.id;
      const status = normalizeContentPublishStatus(payload?.status);
      const loggedInUserName = encodeURIComponent(
        payload?.loggedInUserName || ''
      );
      const contentTypeQuery = isCoreContentType(payload?.contentType)
        ? `&contentType=${encodeURIComponent(mapContentTypeToApi('Core'))}`
        : '';

      if (!contentId) {
        return rejectWithValue({
          errorMessage: 'Content ID is missing',
          description: 'Please save the content before publishing'
        });
      }

      let response;
      if (status === 'Saved') {
        response = await api.put(
          `content/publishContent/${contentId}?loggedInUserName=${loggedInUserName}${contentTypeQuery}`
        );
      } else if (status === 'Publish') {
        response = await api.put(
          `content/unPublishContent/${contentId}?loggedInUserName=${loggedInUserName}${contentTypeQuery}`
        );
      } else {
        return rejectWithValue({
          errorMessage: 'Invalid content status',
          description: `Cannot update publish state for status: ${payload?.status || 'unknown'}`
        });
      }
      return response.data?.payload;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || error);
    }
  }
);

export const saveFlashcard = createAsyncThunk(
  'content/saveFlashcard',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await multipartApi.put(
        `content/saveFlashcard`,
        formData
      );
      return response.data?.payload;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const deleteQuestions = createAsyncThunk(
  'content/deleteQuestions',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.put(
        `content/deleteFlashCardQuestionsById/${payload.id}?loggedInUserName=${payload.userName}`
      );
      return response.data?.payload;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const addNewQuiz = createAsyncThunk(
  'content/addNewQuiz',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await multipartApi.put(`content/saveQuiz`, formData);
      return response.data?.payload;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const deleteQuiz = createAsyncThunk(
  'content/deleteQuiz',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.put(
        `content/deleteQuizById/${payload.id}?loggedInUserName=${payload.userName}`
      );
      return response.data?.payload;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const revertAllAddContentData = createAction(
  'REVERT_ALL_ADD_CONTENT_DATA'
);

export const revertPublishContent = createAction('REVERT_PUBLISH_CONTENT');

export const revertSaveFlashCard = createAction('REVERT_SAVE_FLASHCARD');

export const revertNewTagSection = createAction('REVERT_NEW_TAG_SECTION');

export const revertContentDetails = createAction('REVERT_CONTENT_DETAILS');

export const handleModalStatus = createAction('HANDLE_MODAL_STATUS');

export const contentSlice = createSlice({
  name: 'content',
  initialState: initial,
  extraReducers: builder => {
    builder

      .addCase(handleModalStatus, (state, action) => {
        state.isModalOpen = action.payload;
      })
      .addCase(revertContentDetails, state => {
        state.isGetContentLoading = false;
        state.isGetContentSuccess = false;
        state.isGetContentFailed = false;
        state.contentDetails = null;
        state.getContentErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };
      })
      .addCase(revertAllAddContentData, state => {
        state.isAddNewContentLoading = false;
        state.isAddNewContentSuccess = false;
        state.isAddNewContentFailed = false;
        state.addContentResponse = null;
        state.addNewContentErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };
        state.isUpadteContentResponsesLoading = false;
        state.isUpadteContentResponsesSuccess = false;
        state.isUpadteContentResponsesFailed = false;
        state.upadteContentResponsesErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };
        state.isUpadteContentSettingsLoading = false;
        state.isUpadteContentSettingsSuccess = false;
        state.isUpadteContentSettingsFailed = false;
        state.updateContentSettingsResponse = null;
        state.UpadteContentSettingsErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };
        state.isUpadteContentLoading = false;
        state.isUpadteContentSuccess = false;
        state.isUpadteContentFailed = false;
        state.updateContent = null;
        state.upadteContentErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };
        state.isDeleteContentLoading = false;
        state.isDeleteContentSuccess = false;
        state.isDeleteContentFailed = false;
        state.deleteContentResponse = null;
        state.deleteContentErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };
        state.isGetContentLoading = false;
        state.isGetContentSuccess = false;
        state.isGetContentFailed = false;
        state.contentDetails = null;
        state.getContentErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };
        state.isPublishContentLoading = false;
        state.isPublishContentSuccess = false;
        state.isPublishContentFailed = false;
        state.publishContentResponse = null;
        state.publishContentErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };

        state.isSaveFlashCardLoading = false;
        state.isSaveFlashCardSuccess = false;
        state.isSaveFlashCardFailed = false;
        state.flashCardResponse = null;
        state.flashCardErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };

        state.isDeleteQuestionLoading = false;
        state.isDeleteQuestionSuccess = false;
        state.isDeleteQuestionFailed = false;
        state.deleteQuestionResponse = null;
        state.deleteQuestionErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };

        state.isAddNewQuizLoading = false;
        state.isAddNewQuizSuccess = false;
        state.isAddNewQuizFailed = false;
        state.addNewQuizResponse = null;
        state.addNewQuizErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };
      })
      .addCase(revertPublishContent, state => {
        state.isPublishContentLoading = false;
        state.isPublishContentSuccess = false;
        state.isPublishContentFailed = false;
        state.publishContentResponse = null;
        state.publishContentErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };
      })
      .addCase(revertSaveFlashCard, state => {
        state.isSaveFlashCardLoading = false;
        state.isSaveFlashCardSuccess = false;
        state.isSaveFlashCardFailed = false;
        state.flashCardResponse = null;
        state.flashCardErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };
      })
      .addCase(revertNewTagSection, state => {
        state.isAddNewTagLoading = false;
        state.isAddNewTagSuccess = false;
        state.isAddNewTagFailed = false;
        state.addTagResponse = null;
        state.addNewTagErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };
        state.isAddNewSectionLoading = false;
        state.isAddNewSectionSuccess = false;
        state.isAddNewSectionFailed = false;
        state.addSectionResponse = null;
        state.addNewSectionErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };
      })
      .addCase(getContentList.pending, state => {
        state.isGetContentListLoading = true;
        state.isGetContentListSuccess = false;
        state.isGetContentListFailed = false;
        state.getContentListErrorContainer = {
          error: false,
          errorMessage: '',
          description: '',
          statusCode: 0
        };
      })
      .addCase(getContentList.fulfilled, (state, action) => {
        state.isGetContentListLoading = false;
        state.isGetContentListSuccess = true;
        state.contentList = {
          ...state.contentList,
          contentList: action.payload?.dataList,
          allCount: action.payload?.allCount,
          savedCount: action.payload?.savedCount,
          freeCount: action.payload?.freeCount,
          registeredCount: action.payload?.registeredCount,
          pafCount: action.payload?.pafCount
        };
      })
      .addCase(getContentList.rejected, (state, action) => {
        state.isGetContentListLoading = false;
        state.isGetContentListFailed = true;
        state.contentList = initial.contentList;
        state.getContentListErrorContainer = {
          ...state.getContentListErrorContainer,
          ...action.payload
        };
      })

      .addCase(getSectionList.pending, state => {
        state.isSectionListLoading = true;
        state.isSectionListSuccess = false;
        state.isSectionListFailed = false;
        state.sectionListErrorContainer = {
          error: false,
          errorMessage: '',
          description: '',
          statusCode: 0
        };
      })
      .addCase(getSectionList.fulfilled, (state, action) => {
        state.isSectionListLoading = false;
        state.isSectionListSuccess = true;
        state.sectionList = Array.isArray(action.payload)
          ? action.payload
          : action.payload?.dataList || [];
      })
      .addCase(getSectionList.rejected, (state, action) => {
        state.isSectionListLoading = false;
        state.isSectionListFailed = true;
        state.sectionList = initial.sectionList;
        state.sectionListErrorContainer = {
          ...state.sectionListErrorContainer,
          ...action.payload
        };
      })

      .addCase(getTagList.pending, state => {
        state.isTagListLoading = true;
        state.isTagListSuccess = false;
        state.isTagListFailed = false;
        state.tagListErrorContainer = {
          error: false,
          errorMessage: '',
          description: '',
          statusCode: 0
        };
      })
      .addCase(getTagList.fulfilled, (state, action) => {
        state.isTagListLoading = false;
        state.isTagListSuccess = true;
        state.tagList = action.payload?.dataList;
      })
      .addCase(getTagList.rejected, (state, action) => {
        state.isTagListLoading = false;
        state.isTagListFailed = true;
        state.tagList = initial.sectionList;
        state.tagListErrorContainer = {
          ...state.tagListErrorContainer,
          ...action.payload
        };
      })

      .addCase(addNewTag.pending, state => {
        state.isAddNewTagLoading = true;
        state.isAddNewTagSuccess = false;
        state.isAddNewTagFailed = false;
        state.addNewTagErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };
      })
      .addCase(addNewTag.fulfilled, (state, action) => {
        state.isAddNewTagLoading = false;
        state.isAddNewTagFailed = false;
        state.isAddNewTagSuccess = true;
        state.addTagResponse = action?.payload?.payload;
      })
      .addCase(addNewTag.rejected, (state, action) => {
        state.isAddNewTagLoading = false;
        state.isAddNewTagSuccess = false;
        state.isAddNewTagFailed = true;
        state.addNewTagErrorContainer = {
          ...state.addNewTagErrorContainer,
          ...action.payload
        };
      })

      .addCase(deleteContentTag.pending, state => {
        state.isDeleteContentTagLoading = true;
        state.isDeleteContentTagSuccess = false;
        state.isDeleteContentTagFailed = false;
        state.deleteContentTagErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };
      })
      .addCase(deleteContentTag.fulfilled, (state, action) => {
        state.isDeleteContentTagLoading = false;
        state.isDeleteContentTagFailed = false;
        state.isDeleteContentTagSuccess = true;
        state.deleteContentTagResponse = action?.payload?.payload;
      })
      .addCase(deleteContentTag.rejected, (state, action) => {
        state.isDeleteContentTagLoading = false;
        state.isDeleteContentTagSuccess = false;
        state.isDeleteContentTagFailed = true;
        state.deleteContentTagErrorContainer = {
          ...state.deleteContentTagErrorContainer,
          ...action.payload
        };
      })

      .addCase(addNewSection.pending, state => {
        state.isAddNewSectionLoading = true;
        state.isAddNewSectionSuccess = false;
        state.isAddNewSectionFailed = false;
        state.addNewSectionErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };
      })
      .addCase(addNewSection.fulfilled, (state, action) => {
        state.isAddNewSectionLoading = false;
        state.isAddNewSectionFailed = false;
        state.isAddNewSectionSuccess = true;
        state.addSectionResponse = action?.payload?.payload;
      })
      .addCase(addNewSection.rejected, (state, action) => {
        state.isAddNewSectionLoading = false;
        state.isAddNewSectionSuccess = false;
        state.isAddNewSectionFailed = true;
        state.addNewSectionErrorContainer = {
          ...state.addNewSectionErrorContainer,
          ...action.payload
        };
      })

      .addCase(addNewContent.pending, state => {
        state.isAddNewContentLoading = true;
        state.isAddNewContentSuccess = false;
        state.isAddNewContentFailed = false;
        state.addContentResponse = null;
        state.addNewContentErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };
      })
      .addCase(addNewContent.fulfilled, (state, action) => {
        state.isAddNewContentLoading = false;
        state.isAddNewContentFailed = false;
        state.isAddNewContentSuccess = true;
        state.addContentResponse = action.payload;
      })
      .addCase(addNewContent.rejected, (state, action) => {
        state.isAddNewContentLoading = false;
        state.isAddNewContentSuccess = false;
        state.addContentResponse = null;
        state.isAddNewContentFailed = true;
        state.addNewContentErrorContainer = {
          ...state.addNewContentErrorContainer,
          ...action.payload
        };
      })

      .addCase(getContentById.pending, state => {
        state.isGetContentLoading = true;
        state.isGetContentSuccess = false;
        state.isGetContentFailed = false;
        state.contentDetails = null;
        state.getContentErrorContainer = {
          error: false,
          errorMessage: '',
          description: '',
          statusCode: 0
        };
      })
      .addCase(getContentById.fulfilled, (state, action) => {
        state.isGetContentLoading = false;
        state.isGetContentSuccess = true;
        state.contentDetails = action.payload;
      })
      .addCase(getContentById.rejected, (state, action) => {
        state.isGetContentLoading = false;
        state.isGetContentFailed = true;
        state.contentDetails = null;
        state.getContentErrorContainer = {
          ...state.errorContainer,
          ...action.payload
        };
      })

      .addCase(getContentByIdForQuizInVideo.pending, state => {
        state.isGetContentForQuizLoading = true;
        state.isGetContentForQuizSuccess = false;
        state.isGetContentForQuizFailed = false;
        state.contentDetailsForQuiz = null;
        state.getContentErrorContainerForQuiz = {
          error: false,
          errorMessage: '',
          description: '',
          statusCode: 0
        };
      })
      .addCase(getContentByIdForQuizInVideo.fulfilled, (state, action) => {
        state.isGetContentForQuizLoading = false;
        state.isGetContentForQuizSuccess = true;
        state.contentDetailsForQuiz = action.payload;
      })
      .addCase(getContentByIdForQuizInVideo.rejected, (state, action) => {
        state.isGetContentForQuizLoading = false;
        state.isGetContentForQuizFailed = true;
        state.contentDetailsForQuiz = null;
        state.getContentErrorContainerForQuiz = {
          ...state.errorContainer,
          ...action.payload
        };
      })

      .addCase(updateContent.pending, state => {
        state.isUpadteContentLoading = true;
        state.isUpadteContentSuccess = false;
        state.isUpadteContentFailed = false;
        state.upadteContentErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };
      })
      .addCase(updateContent.fulfilled, (state, action) => {
        state.isUpadteContentLoading = false;
        state.isUpadteContentSuccess = true;
        state.updateContent = action.payload;
      })
      .addCase(updateContent.rejected, (state, action) => {
        state.isUpadteContentLoading = false;
        state.isUpadteContentFailed = true;
        state.upadteContentErrorContainer = {
          ...state.upadteContentErrorContainer,
          ...action.payload
        };
      })

      .addCase(updateContentResponses.pending, state => {
        state.isUpadteContentResponsesLoading = true;
        state.isUpadteContentResponsesSuccess = false;
        state.isUpadteContentResponsesFailed = false;
        state.upadteContentResponsesErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };
      })
      .addCase(updateContentResponses.fulfilled, state => {
        state.isUpadteContentResponsesLoading = false;
        state.isUpadteContentResponsesFailed = false;
        state.isUpadteContentResponsesSuccess = true;
      })
      .addCase(updateContentResponses.rejected, (state, action) => {
        state.isUpadteContentResponsesLoading = false;
        state.isUpadteContentResponsesSuccess = false;
        state.isUpadteContentResponsesFailed = true;
        state.upadteContentResponsesErrorContainer = {
          ...state.upadteContentResponsesErrorContainer,
          ...action.payload
        };
      })

      .addCase(updateContentSettings.pending, state => {
        state.isUpadteContentSettingsLoading = true;
        state.isUpadteContentSettingsSuccess = false;
        state.isUpadteContentSettingsFailed = false;
        state.UpadteContentSettingsErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };
      })
      .addCase(updateContentSettings.fulfilled, (state, action) => {
        state.isUpadteContentSettingsLoading = false;
        state.isUpadteContentSettingsFailed = false;
        state.isUpadteContentSettingsSuccess = true;
        state.updateContentSettingsResponse = action.payload;
      })
      .addCase(updateContentSettings.rejected, (state, action) => {
        state.isUpadteContentSettingsLoading = false;
        state.isUpadteContentSettingsSuccess = false;
        state.isUpadteContentSettingsFailed = true;
        state.UpadteContentSettingsErrorContainer = {
          ...state.UpadteContentSettingsErrorContainer,
          ...action.payload
        };
      })

      .addCase(deleteContent.pending, state => {
        state.isDeleteContentLoading = true;
        state.isDeleteContentSuccess = false;
        state.isDeleteContentFailed = false;
        state.deleteContentErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };
      })
      .addCase(deleteContent.fulfilled, (state, action) => {
        state.isDeleteContentLoading = false;
        state.isDeleteContentFailed = false;
        state.isDeleteContentSuccess = true;
        state.deleteContentResponse = action.payload;
      })
      .addCase(deleteContent.rejected, (state, action) => {
        state.isDeleteContentLoading = false;
        state.isDeleteContentSuccess = false;
        state.isDeleteContentFailed = true;
        state.deleteContentErrorContainer = {
          ...state.deleteContentErrorContainer,
          ...action.payload
        };
      })

      .addCase(publishContent.pending, state => {
        state.isPublishContentLoading = true;
        state.isPublishContentSuccess = false;
        state.isPublishContentFailed = false;
        state.publishContentErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };
      })
      .addCase(publishContent.fulfilled, (state, action) => {
        state.isPublishContentLoading = false;
        state.isPublishContentFailed = false;
        state.isPublishContentSuccess = true;
        state.publishContentResponse = action.payload;
      })
      .addCase(publishContent.rejected, (state, action) => {
        state.isPublishContentLoading = false;
        state.isPublishContentSuccess = false;
        state.isPublishContentFailed = true;
        state.publishContentErrorContainer = {
          ...state.publishContentErrorContainer,
          ...action.payload
        };
      })

      .addCase(saveFlashcard.pending, state => {
        state.isSaveFlashCardLoading = true;
        state.isSaveFlashCardSuccess = false;
        state.isSaveFlashCardFailed = false;
        state.flashCardResponse = null;
        state.flashCardErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };
      })
      .addCase(saveFlashcard.fulfilled, (state, action) => {
        state.isSaveFlashCardLoading = false;
        state.isSaveFlashCardSuccess = true;
        state.flashCardResponse = action.payload;
      })
      .addCase(saveFlashcard.rejected, (state, action) => {
        state.isSaveFlashCardLoading = false;
        state.isSaveFlashCardFailed = true;
        state.flashCardResponse = null;
        state.flashCardErrorContainer = {
          ...state.flashCardErrorContainer,
          ...action.payload
        };
      })

      .addCase(deleteQuestions.pending, state => {
        state.isDeleteQuestionLoading = true;
        state.isDeleteQuestionSuccess = false;
        state.isDeleteQuestionFailed = false;
        state.deleteQuestionResponse = null;
        state.deleteQuestionErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };
      })
      .addCase(deleteQuestions.fulfilled, (state, action) => {
        state.isDeleteQuestionLoading = false;
        state.isDeleteQuestionSuccess = true;
        state.deleteQuestionResponse = action.payload;
      })
      .addCase(deleteQuestions.rejected, (state, action) => {
        state.isDeleteQuestionLoading = false;
        state.isDeleteQuestionFailed = true;
        state.deleteQuestionResponse = null;
        state.deleteQuestionErrorContainer = {
          ...state.deleteQuestionErrorContainer,
          ...action.payload
        };
      })

      .addCase(addNewQuiz.pending, state => {
        state.isAddNewQuizLoading = true;
        state.isAddNewQuizSuccess = false;
        state.isAddNewQuizFailed = false;
        state.addNewQuizResponse = null;
        state.addNewQuizErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };
      })
      .addCase(addNewQuiz.fulfilled, (state, action) => {
        state.isAddNewQuizLoading = false;
        state.isAddNewQuizSuccess = true;
        state.addNewQuizResponse = action.payload;
      })
      .addCase(addNewQuiz.rejected, (state, action) => {
        state.isAddNewQuizLoading = false;
        state.isAddNewQuizFailed = true;
        state.deleteQuestionResponse = null;
        state.addNewQuizErrorContainer = {
          ...state.addNewQuizErrorContainer,
          ...action.payload
        };
      })

      .addCase(deleteQuiz.pending, state => {
        state.isDeleteQuizLoading = true;
        state.isDeleteQuizSuccess = false;
        state.isDeleteQuizFailed = false;
        state.deleteQuizResponse = null;
        state.deleteQuizErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };
      })
      .addCase(deleteQuiz.fulfilled, (state, action) => {
        state.isDeleteQuizLoading = false;
        state.isDeleteQuizSuccess = true;
        state.deleteQuizResponse = action.payload;
      })
      .addCase(deleteQuiz.rejected, (state, action) => {
        state.isDeleteQuizLoading = false;
        state.isDeleteQuizFailed = true;
        state.deleteQuestionResponse = null;
        state.deleteQuizErrorContainer = {
          ...state.deleteQuizErrorContainer,
          ...action.payload
        };
      });
  }
});

export default contentSlice.reducer;
